import React from 'react';
import './DeliveryIcon.less';

const DeliveryIcon = () => {
  return (
    <figure className="delivery-icon" />
  );
};

export default DeliveryIcon;



// WEBPACK FOOTER //
// ./src/components/Delivery/DeliveryIcon.js